import React from 'react'
import { Spin, Button } from 'antd'
import AssessmentPanel from './AssessmentPanel'
import { PatientDetailWrapper, PopUp, PopUpMessage, PopUpButtonContainer } from './index.styled'
import PatientProfilePanel from './PatientProfilePanel'
import PatientReportPanel from './PatientReportPanel'
import { usePatientDetail } from './usePatientDetail'
import { APIStatus } from '../../../redux/types'

export default function PatientDetailScreen() {
  const {
    currentPatient,
    patientDetailsStatus,
    patientDetailsError,
    forceCheckInPatientStatus,
    handleRetry,
    // handleForceCheckInPatient,
    handlePreviousPatient,
    handleNextPatient,
    canGoPrevious,
    canGoNext,
    navigate,
  } = usePatientDetail()

  if (patientDetailsStatus === APIStatus.pending) {
    return (
      <PatientDetailWrapper>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '851px' }}
        >
          <Spin />
        </div>
      </PatientDetailWrapper>
    )
  }

  if (patientDetailsStatus === APIStatus.rejected) {
    return (
      <PatientDetailWrapper>
        <PopUp open={true} centered mask={true} maskClosable={false} footer={null} closable={false}>
          <PopUpMessage>{patientDetailsError || 'Failed to load patient details'}</PopUpMessage>
          <PopUpButtonContainer>
            <Button
              children={'Retry'}
              style={{
                width: 89,
                height: 38,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#007f7c',
                color: 'var(--color-text-secondary)',
              }}
              onClick={handleRetry}
            ></Button>
          </PopUpButtonContainer>
        </PopUp>
      </PatientDetailWrapper>
    )
  }

  if (!currentPatient) {
    return (
      <PatientDetailWrapper>
        <div
          style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '851px' }}
        >
          <span>No patient data available</span>
        </div>
      </PatientDetailWrapper>
    )
  }

  return (
    <PatientDetailWrapper>
      <PatientProfilePanel
        // handleForceCheckInPatient={handleForceCheckInPatient}
        forceCheckInPatientStatus={forceCheckInPatientStatus}
        handlePreviousPatient={handlePreviousPatient}
        handleNextPatient={handleNextPatient}
        canGoPrevious={canGoPrevious}
        canGoNext={canGoNext}
        navigate={navigate}
      />

      <AssessmentPanel />

      <PatientReportPanel />
    </PatientDetailWrapper>
  )
}
